import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { ApiService } from '@gray/domain/http/api.service';
import { JwtService } from '@gray/domain/http/jwt.service';
import { ICoach } from '../models/coach.model';
import { CoachStateService } from './coach-state.service';

@Injectable({providedIn: 'root'})
export class CoachAuthService {

  private apiPrefix = '/coach/authentication';

  constructor(
    private api: ApiService,
    private jwtService: JwtService,
    private coachState: CoachStateService,
    private router: Router,
  ) {
  }

  login(data: object): Observable<any> {
    return this.api.post(`${this.apiPrefix}/login`, data);
  }

  me(): Observable<any> {
    return this.api.get(`${this.apiPrefix}/me`);
  }

  changePassword(data: object): Observable<any> {
    return this.api.patch(`${this.apiPrefix}/password`, data);
  }

  /**
   * Runs before the app starts: restores the session from the token cookie, and drops the
   * cookie when the token no longer resolves to an active coach.
   */
  loadCoach() {
    const token = this.jwtService.getToken();
    if ((!token) || (token.length < 3)) {
      return Promise.resolve();
    }

    return this.me().toPromise().then(r => {
      this.coachState.setCurrentCoach(r.data as ICoach);
    }).catch(() => {
      this.jwtService.destroyToken();
      this.coachState.clear();
    });
  }

  logout() {
    this.jwtService.destroyToken();
    this.coachState.clear();
    this.router.navigateByUrl('/auth/login');
  }
}
